import { type FC } from "react";
import "./GridImages.scss";
import { ImageType } from "../../../store/productSlice/type";
import { getImagePath } from "../../../services/image-path";

export interface GridImagesProps {
	images?: ImageType[];
}

export interface GridImagesComponent extends FC<GridImagesProps> { }

export const GridImages: GridImagesComponent = ({ images }) => {
	return (
		<div
			className="GridImages"
		>
			{images?.map(({ url }) => (
				<div className="Item">
					<img className="Image" src={getImagePath(url)} alt="" />
				</div>
			))}
		</div>
	);
};
